import TasksTabContent from "../../_components/TasksTabContent";

export default function MyTasksPage() {
  return (
    <TasksTabContent
      body="View and manage tasks assigned to me or unassigned tasks I created"
      source="my_tasks_tab"
      queryOptions={{ myTasks: true, showUnassignedChip: true }}
      hideUserChips
    />
  );
}
